import { createReducer, createNamespacer } from './../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    edit: {
        activeTab: '1',
        showSpoolInput:false,
        showEditPopup: false,
        editSpoolId: '',
        editPackageId:'',
        newSpoolComment: {},
        spoolComments: {
            value: [],
            error: "",
            showError: "",
        },
        spoolDate: {
            value: "",
            error: "",
        },
        received: false,
        canUpdateRequiredDate: false,
    },
}

const editSpools = createNamespacer("EDIT_SPOOLS")

export const editReducer = createReducer(initialState.edit, {
    [editSpools("EDIT_SPOOL")]: (state, action) => { 
        return {
            ...state,
            showEditPopup: !state.showEditPopup,
            editSpoolId: action.payload.spoolId,
            spoolDate: {
                ...state.spoolDate,
                value: action.payload.spoolRequiredDate
            },
            
        }
    },
    [editSpools("TOGGLE_EDIT_SPOOL_POPUP")]: (state, action) => {
        return {
            ...state,
            showEditPopup: !state.showEditPopup,
            activeTab:'1',
            newSpoolComment:{},
            spoolComments:{
                ...initialState.edit.spoolComments,
            },
            showSpoolInput:false,
            spoolDate: {
                ...initialState.edit.spoolDate,
            },
        }
    },
    [editSpools("TOGGLE_TAB")]:(state,action) => {
        return {
            ...state,
            activeTab:action.payload.value,
            // commentThread: true
        }
    },
    [editSpools("SHOW_SPOOL_COMMENT_TEXT_AREA")]: (state, action) => {
        return {
            ...state,
            showSpoolInput: true,
        }
    },
    [editSpools("SET_SPOOL_REQUIRED_DATE")]: (state, action) => {
        return {
            ...state,
            spoolDate: {
                ...state.spoolDate,
                value: action.payload.date
            },
        }
    },
    [editSpools("SET_SPOOLS")]: (state, action) => {
        return {
            ...state,
            spoolComments: {
                ...state.spoolComments,
                value: action.payload.comments
            },
            editPackageId:action.payload.packageId,
            received: action.payload.received,
            canUpdateRequiredDate: action.payload.can_update_required_date,
        }
    },
    [editSpools("ADD_USER_ID")]: (state, action) => {
        return {
            ...state,
            newSpoolComment: {
                ...state.newSpoolComment,
                userId: action.payload.value
            }
        }
    },
    [editSpools("SET_NEW_COMMENT")]:(state, action) => {

        return {
            ...state,
            newSpoolComment: {
                ...state.newSpoolComment,
                description: action.payload.value
            }
        }
    },
    [editSpools("EDIT_COMMENT")]: (state, action) => {
        return {
            ...state,
            spoolComments: {
                ...state.spoolComments,
                value: action.payload.comments
            }
        }
    },
    [editSpools("SET_COMMENTS")]: (state, action) => {
        return {
            ...state,
            spoolComments: {
                ...state.spoolComments,
                value: action.payload.updatedComments
            }
        }
       
    },
    [editSpools("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.edit
        }
    },
    [editSpools("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [editSpools("SET_SHOW_EDIT_SPOOL")]: (state, action) => {
        return {
            ...state,
            showEditPopup: action.payload.value,
            newSpoolComment:{},
            showSpoolInput:false
        }
    },
})
